import React from "react";
import { Navbar, Nav, Container, Dropdown, Image } from "react-bootstrap";
import { HouseFill } from "react-bootstrap-icons";
import "bootstrap/dist/css/bootstrap.min.css";
import "./navbar.css";
import photo from "../assets/LOGO.png";
import { Link } from "react-router-dom";
import logowhite from "../assets/logos-2.png";


const NavbarFacach = () => {
  return (
    <div>
      <Navbar expand="lg" className="navbar-custom" variant="dark">
        <Container>
          <Navbar.Brand href="#home">
           
            <Image
              src={logowhite}
              alt="Logo"
              className="dropdown-logo"
              style={{ width: "300px" }}
            />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbar-nav" className="text-white" />
          <Navbar.Collapse id="navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link as={Link} to="/" style={{ fontSize: "18px" }}>
                <HouseFill style={{ marginRight: "5px" }} />
                Inicio
              </Nav.Link>

              {/*Somos FACACH Con Submenu */}
              <Dropdown className="hover-dropdown">
                <Dropdown.Toggle
                  as={Nav.Link}
                  to="/"
                  style={{ fontSize: "18px" }}
                >
                  Somos FACACH
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <div
                    className="dropdown-items"
                    style={{
                      display: "grid",
                      gridTemplateColumns: "80px auto",
                      gap: "15px",
                      padding: "10px",
                      alignItems: "start",
                    }}
                  >
                    <div
                      className="dropdown-header-row"
                      style={{ width: "100%", height: "auto" }}
                    >
                      <Image
                        src={photo}
                        alt="Logo"
                        className="dropdown-logo"
                        style={{ width: "100%", marginTop: "30px" }}
                      />
                    </div>

                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Dropdown.Item as={Link} to="/principios">
                        Misión, Visión y Principios
                      </Dropdown.Item>
                      <Dropdown.Item as={Link} to="/estructura">
                        Estructura Organizativa y Dirigencia
                      </Dropdown.Item>
                      <Dropdown.Item as={Link} to="/RedInstituto">
                        Red Institucional
                      </Dropdown.Item>
                      <Dropdown.Item href="/usuariocoop">
                        Usuario Cooperativo
                      </Dropdown.Item>
                       <Dropdown.Item href="/biblioteca">
                      Biblioteca Virtual
                      </Dropdown.Item>
                      <Dropdown.Item href="/comitesMain">
                      Comités
                      </Dropdown.Item>
                    </div>
                   
                  </div>
                </Dropdown.Menu>
              </Dropdown>

              <Dropdown className="hover-dropdown">
                <Dropdown.Toggle
                  as={Nav.Link}
                  to="/"
                  style={{ fontSize: "18px" }}
                >
                  Servicios
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <div
                    className="dropdown-items"
                    style={{
                      display: "grid",
                      gridTemplateColumns: "80px auto",
                      gap: "15px",
                      padding: "10px",
                      alignItems: "start",
                    }}
                  >
                    <div
                      className="dropdown-header-row"
                      style={{ width: "100%", height: "auto" }}
                    >
                      <Image
                        src={photo}
                        alt="Logo"
                        className="dropdown-logo"
                        style={{ width: "100%", marginTop: "30px" }}
                      />
                    </div>

                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Dropdown.Item as={Link} to="/operaciones">
                        Operaciones Financieras
                      </Dropdown.Item>
                      <Dropdown.Item as={Link} to="/capacitaciones">
                        Capacitación
                      </Dropdown.Item>
                      <Dropdown.Item href="/asistencia">
                        Asistencia Técnica
                      </Dropdown.Item>
                      <Dropdown.Item href="/dgrv">
                        Herramientas DGRV
                      </Dropdown.Item>
                      <Dropdown.Item href="/cumplimientos">
                        Cumplimiento
                      </Dropdown.Item>
                      <Dropdown.Item href="/riesgos">Riesgos</Dropdown.Item>
                    </div>
                  </div>
                </Dropdown.Menu>
              </Dropdown>

              <Dropdown className="hover-dropdown">
                <Dropdown.Toggle
                  as={Nav.Link}
                  to="/"
                  style={{ fontSize: "18px" }}
                >
                  Transparencia
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <div
                    className="dropdown-items"
                    style={{
                      display: "grid",
                      gridTemplateColumns: "80px auto",
                      gap: "15px",
                      padding: "10px",
                      alignItems: "start",
                      
                    }}
                  >
                    <div
                      className="dropdown-header-row"
                      style={{ width: "100%", height: "auto", marginRight: "10px", }}
                    >
                      <Image
                        src={photo}
                        alt="Logo"
                        className="dropdown-logo"
                        style={{ width: "100%", marginTop: "10px" }}
                      />
                    </div>

                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Dropdown.Item as={Link} to="/financieros">
                        Estados Financieros
                      </Dropdown.Item>
                      <Dropdown.Item as={Link} to="/memoria">
                        Memoria Institucional
                      </Dropdown.Item>
                      <Dropdown.Item as={Link} to="/sistema-federado">
                        Sistema Federado FACACH
                      </Dropdown.Item>
                    </div>
                  </div>
                </Dropdown.Menu>
              </Dropdown>

              {/*
               <Dropdown className="hover-dropdown">
                <Dropdown.Toggle as={Nav.Link} to="/" style={{ fontSize: "18px" }}>
                  Más
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <div
                    className="dropdown-items"
                    style={{
                      display: "grid",
                      gridTemplateColumns: "80px auto",
                      gap: "15px",
                      padding: "10px",
                      alignItems: "start",
                    }}
                  >
                    <div
                      className="dropdown-header-row"
                      style={{ width: "100%", height: "auto" }}
                    >
                      <Image
                        src={photo}
                        alt="Logo"
                        className="dropdown-logo"
                        style={{ width: "100%", marginTop: "30px" }}
                      />
                    </div>

                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Dropdown.Item as={Link} to="/boletines">
                        Boletínes
                      </Dropdown.Item>
                      <Dropdown.Item as={Link} to="/contacto">
                        Contactenos
                      </Dropdown.Item>
                     
                    </div>
                  </div>
                </Dropdown.Menu>
              </Dropdown>
*/}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <div style={{ height: "2px", backgroundColor: "#e87813" }}></div>
    </div>
  );
};

export default NavbarFacach;
